export default {
  methods: {
    getProductOptions: function (index) {
      const products = this.$store.getters['cart/products']
      if (!products[index]) {
        return []
      }

      let options = []
      for (let optionType in products[index].cp_product_options) {
        if (optionType === 'count_pages') {
          options.push('Count pages: ' + products[index].cp_product_options[optionType])
        }

        for (let option of products[index].cpProductInfo.options) {
          if (option.type === optionType && option.option_reference === products[index].cp_product_options[optionType]) {
            options.push(option.type_name + ': ' + option.note)
          }
        }
      }

      return options
    }
  }
}
